var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiquidDry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 133,
    viewBox: "0 0 92 133",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.91c33.23-7.387 57.656 9.721 92 0V18.9H0V1.91z",
    fill: "#D2EAF9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 18.9h92v18.9H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDEC9B",
    d: "M0 37.8h92v63H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 100.8h92v26.5a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5v-26.5z",
    fill: "#8F2516"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiquidDry);
export default __webpack_public_path__ + "static/media/liquid-dry.fd7014ce3acb1d482a51729e48218e87.svg";
export { ForwardRef as ReactComponent };